import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CallServiceAbstract } from "../call.service";
import { SettingsService } from "../../settings.service";
import { AuthenticationService } from "../../auth/Authentication/authentication.service";
import { Subject } from 'rxjs';
import { NotificationService } from '../../notification.service';
import { StateService } from '../../state/state.service';

@Injectable({
    providedIn: 'root'
  })

export class ProductionTechnologiesRecipeIngredients extends CallServiceAbstract {
    constructor(
        http: HttpClient,
        settings: SettingsService,
        authentication: AuthenticationService,
        notify: NotificationService,
        state: StateService,
        ) {
        super(http, settings, authentication, notify, state, 'Production_Technologies_RecipeIngredients', 'Съставка на технология');
        }

    public predefineState(state) {
        state = super.predefineState(state);
        state.expand.push('Store($select=Id,Name)');
        state.expand.push('Material($select=Name)');
        state.expand.push('Operation($select=Name)'); //todo

        //експанд-а в технологията. Защото при зареждането се търси по съставка
        state.expand.push('Recipe($expand=Store($select=Id,Name),Product($select=Name,PartNumber,ProductType,CustomProperty_StoreForProdOrder;$expand=MeasurementUnit($select=Code),ProductType),Ingredients($expand=Material($select=Id,StandardCostPerLot,Name,PartNumber,ProductType,CustomProperty_StoreForProdOrder;$expand=MeasurementUnit($select=Code),Dimensions($expand=DestQuantityUnit($select=Code),SourceQuantityUnit($select=Code)),ProductType),Store($select=Id,Name),UsageUnit($select=Code)),Operations)')
        return state;
    }

    filterRecipeies(filter) {
        let obz = new Subject();
        this.query(filter).subscribe(
          (data) => obz.next(data),
          (err) => obz.error(err)
        );
        return obz.asObservable();
      }
}